import * as React from 'react'
import DataGrid, { DataGridProps } from 'react-data-grid'
import { useRsi } from '../hooks/useRsi'

interface Props<Data> extends DataGridProps<Data> {
    rowHeight?: number
    hiddenHeader?: boolean
}

export const Table = <Data,>({ className, ...props }: Props<Data>) => {

    // function rowClass(row: Data) {
    //     return styles.row;
    // }

    
    const { rtl } = useRsi()
    return <DataGrid defaultColumnOptions={{ resizable: true }}  className={'rdg-light ' + className || ''} direction={rtl ? 'rtl' : 'ltr'} {...props} />
}
